module.exports = __webpack_public_path__ + "img/1080_19.64c77fb5.jpg";